// // actions.js
import axiosInstance from "../../api/axios";
import { User } from "../../utils/types/user";

export const fetchPackages = () => {
  return (dispatch: any) => {
    axiosInstance
      .get("/indicator-package")
      .then((response: any) => {
        dispatch({ type: "FETCH_PACKAGES_SUCCESS", payload: response.data });
      })
      .catch((error: any) => {
        dispatch({ type: "FETCH_PACKAGES_ERROR", payload: error });
      });
  };
};
export const fetchIndicators = (packageId: number) => {
  return (dispatch: any) => {
    axiosInstance
      .get(`/indicator/byPackage/${packageId}`)
      .then((response: any) => {
        dispatch({ type: "FETCH_INDICATORS_SUCCESS", payload: response.data });
      })
      .catch((error: any) => {
        dispatch({ type: "FETCH_INDICATORS_ERROR", payload: error });
      });
  };
};

export const fetchDepartments = () => {
  return (dispatch: any) => {
    axiosInstance
      .get("/department")
      .then((response: any) => {
        dispatch({ type: "FETCH_DEPARTMENT_SUCCESS", payload: response.data });
      })
      .catch((error: any) => {
        dispatch({ type: "FETCH_DEPARTMENT_ERROR", payload: error });
      });
  };
};
export const fetchTechnicalArea = () => {
  return (dispatch: any) => {
    axiosInstance
      .get("/technical-area")
      .then((response: any) => {
        dispatch({
          type: "FETCH_TECHNICAL_AREA_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error: any) => {
        dispatch({ type: "FETCH_TECHNICAL_AREA_ERROR", payload: error });
      });
  };
};
export const getProjects = () => {
  return (dispatch: any) => {
    axiosInstance
      .get("/project")
      .then((response: any) => {
        dispatch({ type: "GET_PROJECT_SUCCESS", payload: response.data });
      })
      .catch((error: any) => {
        dispatch({ type: "GET_PROJECT_ERROR", payload: error });
      });
  };
};
export const getProjectsView = () => {
  return (dispatch: any) => {
    axiosInstance
      .get("/project/view")
      .then((response: any) => {
        dispatch({ type: "GET_PROJECT_SUCCESS", payload: response.data });
      })
      .catch((error: any) => {
        dispatch({ type: "GET_PROJECT_ERROR", payload: error });
      });
  };
};

export const getUsers = () => {
  return (dispatch: any) => {
    axiosInstance
      .get("/user")
      .then((response: any) => {
        dispatch({ type: "GET_USERS_SUCCESS", payload: response.data });
      })
      .catch((error: any) => {
        dispatch({ type: "GET_USERS_ERROR", payload: error });
      });
  };
};

export const getFilteredUsers = (id:number | undefined) => {
  return (dispatch: any) => {
    axiosInstance
      .get("/user/facility/"+id)
      .then((response: any) => {
        dispatch({ type: "GET_USERS_SUCCESS", payload: response.data });
      })
      .catch((error: any) => {
        dispatch({ type: "GET_USERS_ERROR", payload: error });
      });
  };
};

export const getRoles = () => {
  return (dispatch: any) => {
    axiosInstance
      .get("/role")
      .then((response: any) => {
        dispatch({ type: "GET_ROLES_SUCCESS", payload: response.data });
      })
      .catch((error: any) => {
        dispatch({ type: "GET_ROLES_ERROR", payload: error });
      });
  };
};

export const getPermissions = () => {
  return (dispatch: any) => {
    axiosInstance
      .get("/permission")
      .then((response: any) => {
        dispatch({ type: "GET_PERMISSIONS_SUCCESS", payload: response.data });
      })
      .catch((error: any) => {
        dispatch({ type: "GET_PERMISSIONS_ERROR", payload: error });
      });
  };
};

export const getMenus = () => {
  return (dispatch: any) => {
    axiosInstance
      .get("/menu")
      .then((response: any) => {
        dispatch({ type: "GET_MENU_SUCCESS", payload: response.data });
      })
      .catch((error: any) => {
        dispatch({ type: "GET_MENU_ERROR", payload: error });
      });
  };
};

export const getFacilityAdmins = () => {
  return (dispatch: any) => {
    axiosInstance
      .get("/user")
      .then((response: any) => {
        let admin = response.data.filter((user: User) => {
          return (
            user.is_facility_admin === true &&
            user.approval_requests.length !== 0
          );
        });
        console.log("admins filterd: ", admin);

        dispatch({ type: "GET_USERS_SUCCESS", payload: admin });
      })
      .catch((error: any) => {
        dispatch({ type: "GET_USERS_ERROR", payload: error });
      });
  };
};
export const getChallenges = () => {
  return (dispatch: any) => {
    axiosInstance
      .get("/challenge")
      .then((response: any) => {
        dispatch({ type: "GET_CHALLENGE_SUCCESS", payload: response.data });
      })
      .catch((error: any) => {
        dispatch({ type: "GET_CHALLENGE_ERROR", payload: error });
      });
  };
};

export const getFacilities = () => {
  return (dispatch: any) => {
    axiosInstance
      .get("/facility")
      .then((response: any) => {
        dispatch({ type: "GET_FACILITY_SUCCESS", payload: response.data });
      })
      .catch((error: any) => {
        dispatch({ type: "GET_FACILITY_ERROR", payload: error });
      });
  };
};